define([
    'jquery',
    './console',
    './vendor/slick'
], function ($, console) {
    'use strict';

    var selector = '.js-carousel';
    var $carouselEl;
    var onResizeTimeout;

    var activate = function () {
        $carouselEl = $(selector);

        if ($carouselEl.length === 0) {
            return;
        }

        // @see https://github.com/kenwheeler/slick/pull/2681/files
        // @see https://github.com/kenwheeler/slick/pull/1661

        $carouselEl.slick({
            // lazyLoad: 'ondemand', // 'ondemand', //'ondemand',
            lazyLoad: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 4000,
            arrows: false,
            fade: true,
            pauseOnHover: false
            // prevArrow: '<a href="#" class="slick-prev"><span></span></a>',
            // nextArrow: '<a href="#" class="slick-next"><span></span></a>'
        });

        // $carouselEl.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        //     console.log('slick.beforeChange', currentSlide, nextSlide);
        //
        //     var nextSlideImg = $('.slick-slider .slick-slide[data-slick-index="' + nextSlide + '"]');
        //
        //     console.log(nextSlideImg);
        //
        //     const lazySlides = function (el, attr, lazyAttr) {
        //
        //         nextSlideImg
        //             .find(el)
        //             .each(function (i, img) {
        //                 let $img = $(img);
        //
        //                 if (el === 'img[data-lazy]_renamed') {
        //                     let imageSource = $img.attr('data-lazy');
        //                     let imageToLoad = document.createElement('img');
        //
        //                     imageToLoad.onload = function() {
        //                         $img.animate({opacity: 0}, 100, function() {
        //                             $img
        //                                 .attr(attr, $img.data(lazyAttr))
        //                                 .animate({ opacity: 1 }, 200, function() {
        //                                     $img
        //                                         .removeAttr('data-lazy data-srcset data-sizes')
        //                                         .removeClass('slick-loading');
        //                                 });
        //                         });
        //                     };
        //
        //                     imageToLoad.onerror = function() {
        //                         $img
        //                             .removeAttr( 'data-lazy' )
        //                             .removeClass( 'slick-loading' )
        //                             .addClass( 'slick-lazyload-error' );
        //                     };
        //
        //                     imageToLoad.src = imageSource;
        //                 } else {
        //                     $img.attr(attr, $img.data(lazyAttr))
        //                 }
        //             })
        //     }
        //
        //     lazySlides('picture source[data-lazy-srcset]', 'srcset', 'lazy-srcset');
        //     lazySlides('img[data-lazy]', 'src', 'lazy');
        // });

        // $carouselEl.on('lazyLoaded', function (evt, slick, $img) {
        //     console.log('lazyLoaded', $img);
        //
        //     $img
        //         // Find the parent <picture> tag of img
        //         .closest('picture')
        //         // Find <source> tags with data-lazy-srcset attribute
        //         .find('[data-lazy-srcset]')
        //         // Copy data-lazy-srcset to srcset
        //         .each(function (i, source) {
        //             let $source = $(source);
        //             $source.attr('srcset', $source.data('lazy-srcset'));
        //             $source.removeAttr('data-lazy-srcset');
        //         });
        // });

        $(window).off('resize orientationchange', function() {
            if ($(selector).hasClass('slick-initialized')) {
                $(selector).slick('resize');
            }
        });
        $(window).on('resize orientationchange', function() {
            if ($(selector).hasClass('slick-initialized')) {
                $(selector).slick('resize');
            }
        });
    };

    var deactivate = function () {
        $(selector).slick('unslick');

        $(window).off('resize orientationchange', function() {
            $(selector).slick('resize');
        });
    };

    return {
        activate: activate,
        deactivate: deactivate
    };
});